import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-6">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-4"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="lg:col-span-7 lg:col-start-6">
          <AccordionList items={items} openBehavior={openBehavior} />
        </div>
      </div>
    </StratosSection>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
